import { Injectable } from "@angular/core";
import { TelemetryService } from "@obg/ngx.global.evo";

import { CookieConsentConfigService } from "../../data-protection/cookie-consent/cookie-consent.config";
import { ConsentType, GDPRConsent, UserConsent } from "../../data-protection/cookie-consent/cookie-consent.model";
import { DataProtectionEventName } from "../data-protection/data-protection-telemetry.model";

@Injectable({
	providedIn: "root",
})
export class DataProtectionTelemetryService {
	constructor(
		private telemetryService: TelemetryService,
		private cookieConsentConfigService: CookieConsentConfigService
	) {}

	sendDataProtectionEvents(userConsent: UserConsent) {
		const consentData: Record<string, any> = this.isGDPRConsentAccepted(userConsent.gdprConsent)
			? { event: DataProtectionEventName.GDPRConsent, ...userConsent.gdprConsent }
			: { ...userConsent.gdprConsent };

		this.telemetryService.track(consentData);

		if (
			!this.cookieConsentConfigService.getOneTrustIsEnabled() &&
			userConsent.consentCookie.marketing === ConsentType.Accepted
		) {
			this.telemetryService.track({ event: DataProtectionEventName.MarketingConsent });
		}
	}

	private isGDPRConsentAccepted(gdprConsent: GDPRConsent): boolean {
		if (!gdprConsent) {
			return false;
		}
		type gdprPropertyKeys = keyof typeof gdprConsent;
		const gdprAcceptedKeyProperties: gdprPropertyKeys[] = [
			"GDPRTargetingAccepted",
			"GDPRPerformanceAccepted",
			"GDPRFunctionalAccepted",
		];
		let isGDPRAccepted = false;

		for (const gdprAcceptedKeyProperty of gdprAcceptedKeyProperties) {
			const acceptedProperty = gdprConsent[gdprAcceptedKeyProperty];
			if (acceptedProperty && acceptedProperty === "1") {
				isGDPRAccepted = true;
			}
		}
		return isGDPRAccepted;
	}
}
